import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import request, { isSalesSupport } from '../../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../../design/css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderStatus } from '../../utils/constant';
import { getFormattedDate } from '../../utils/utils';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';

import Table from './Table';
import Pagination from '../../salesRepDashboard/Pagination';
import SearchBar from './components/searchBar';
import Filters from './components/filters';

const BusinessAppOrders = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;

  const {
    incomplete,
    pendingValidation,
    waitingOnCredit,
    waitingOnSales,
    contractSigned,
    contractSent,
    orderCanceled,
    contractExpired,
    orderInstalled,
    orderPlaced,
    orderActivated,
    orderShipped,
    orderCompleted
  } = orderStatus;

  // const filterData = {
  //   salesRepNames,
  //   assignees,
  //   channels
  // };

  const { data: pageLayout } = useFetchContentfulData(
    'businessAppSalesRepDashboard'
  );
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [filters, setFilters] = useState({
    productInOrderFor: '',
    status: '',
    salesRepId: '',
    createdBy: '',
    province: '',
    channelId: '',
    filterCriteria: '',
    startDate: '',
    endDate: ''
  });

  const fetchOrders = () => {
    setPageLoading(true);
    request
      .get(
        `/orders?type=BA&pageNumber=${pageNumber}&pageSize=${_.get(
          pageLayout,
          'ordersPerPage',
          10
        )}${isSalesSupport ? `&saleSupport=true` : ''}`
      )
      .then(response => {
        setOrdersList(_.get(response, 'data.results', []));
        setTotalOrders(_.get(response, 'data.totalCount', 0));
        setPageLoading(false);
      })
      .catch(() => {});
  };

  const getPayload = () => {
    const payload = {
      ...filters,
      pageNumber: 1,
      pageSize: 10,
      type: 'BA',
      status: filters.status || [
        incomplete,
        pendingValidation,
        waitingOnCredit,
        waitingOnSales,
        contractSigned,
        contractSent,
        orderCanceled,
        contractExpired,
        orderInstalled,
        orderPlaced,
        orderActivated,
        orderShipped,
        orderCompleted
      ]
    };

    if (filters.createdBy) payload.createdBy = _.get(filters, 'createdBy.0.id');
    if (filters.province)
      payload.province = filters.province.map(row => row.label);
    if (filters.channelId)
      payload.channelId = filters.channelId.map(row => row.value);
    if (filters.startDate)
      payload.startDate = getFormattedDate(filters.startDate);
    if (filters.endDate) payload.endDate = getFormattedDate(filters.endDate);

    return payload;
  };

  const setOrders = data => {
    setOrdersList(_.get(data, 'data.results', []));
    setTotalOrders(_.get(data, 'data.totalCount', 0));
  };

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
      <DimpleDivider />
      <ContentWrapper style={{ padding: '0 4rem' }}>
        <Box>
          <Filters
            setOrders={setOrders}
            filters={filters}
            setFilters={setFilters}
            getPayload={getPayload}
          />
          <DimpleDivider />
          <SearchBar setOrders={setOrders} fetchOrders={fetchOrders} />
          {pageLoading && <Spinner spinning label="Loading Orders..." />}
          {!pageLoading && ordersList.length === 0 ? (
            <Heading level="h3">{noOrders}</Heading>
          ) : (
            <>
              {!pageLoading && (
                <>
                  <Box
                    style={{
                      margin: '2rem',
                      border: '1px solid #e3e3e3'
                    }}
                  >
                    <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
                      {`${_.get(
                        pageLayout,
                        'tableTitle',
                        ''
                      )} (${totalOrders})`}
                    </TopbarWrapper>
                    <Table
                      pageLayout={pageLayout}
                      data={ordersList}
                      fetchOrders={fetchOrders}
                    />
                  </Box>
                  <Pagination
                    ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
                    totalOrders={totalOrders}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                  />
                </>
              )}
            </>
          )}
        </Box>
      </ContentWrapper>
    </>
  );
};

export default BusinessAppOrders;
